import { useState } from 'react'
import { Input, Button, Tooltip, Space, theme } from 'antd'
import { SearchOutlined, EditOutlined, CloseOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../Stores'
import NewChatModal from './NewChatModal'

const ChatSearch = observer(() => {
  const { chatStore, uiStore } = useStore()
  const { token } = theme.useToken()
  const [isNewChatOpen, setIsNewChatOpen] = useState(false)

  return (
    <div
      style={{
        padding: '12px 12px 8px',
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        display: 'flex',
        gap: 8,
        alignItems: 'center',
      }}
    >
      {uiStore.isMobile && (
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={() => uiStore.closeDrawer()}
          style={{ flexShrink: 0 }}
        />
      )}
      <Space.Compact style={{ flex: 1 }}>
        <Input
          placeholder="Пошук чатів..."
          prefix={<SearchOutlined style={{ color: token.colorTextQuaternary }} />}
          value={chatStore.searchQuery}
          onChange={(e) => chatStore.setSearchQuery(e.target.value)}
          allowClear
        />
        <Tooltip title="Новий чат">
          <Button icon={<EditOutlined />} onClick={() => setIsNewChatOpen(true)} />
        </Tooltip>
      </Space.Compact>

      <NewChatModal open={isNewChatOpen} onClose={() => setIsNewChatOpen(false)} />
    </div>
  )
})

export default ChatSearch
